import { Button, Stack, Typography, useTheme } from "@mui/material";
import { lowerFirst } from "lodash-es";
import type { FC } from "react";
import type { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";
import { useContactAdvisor } from "web_myplann/Shared/Hooks/useContactAdvisor";

type Props = {
	open: boolean;
	type?: CalculatorType;
	onClose: () => void;
};

export const CalculatorUnavailableDrawer: FC<Props> = ({
	open,
	type,
	onClose,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const { openChat } = useContactAdvisor();
	const product = type ? t(Resources.Calculators.Names[type]) : "";

	const writeToAdvisor = () => {
		onClose();
		void openChat(
			t(Resources.Calculators.Unavailable.ChatMessage, {
				product: lowerFirst(product),
			}),
		);
	};

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={onClose}
			title={t(Resources.Calculators.Unavailable.Title)}
		>
			<Stack
				px={theme.spacingTokens.lg}
				pb={theme.spacingTokens.lg}
				gap={theme.spacingTokens.xl}
			>
				<Typography variant="body1" color={theme.palette.grey[500]}>
					{t(Resources.Calculators.Unavailable.Text, { product })}
				</Typography>
				<Button variant="primary" onClick={writeToAdvisor}>
					{t(Resources.Calculators.Unavailable.Button)}
				</Button>
			</Stack>
		</MyPlannDrawer>
	);
};
